import { API_URL } from "env";
import { AllPostsAPIResponse, CategoryTree, CategoryUploadInterface, Post, PostUploadInterface } from './type';

const API_USE = API_URL

async function getAllPosts(page = 1, per_page = 10): Promise<AllPostsAPIResponse> {
    try {
        const res = await fetch(`${API_USE}api/v1/be/posts?page=${page}&per_page=${per_page}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });
        const data = await res.json();
        return data;
    } catch (error) {
        console.error("Error fetching posts:", error);
        throw error;
    }
}

async function getPostById(id: number): Promise<Post> {
    try {
        const res = await fetch(`${API_USE}api/v1/be/posts/${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });
        const data = await res.json();
        return data;
    } catch (error) {
        console.error(`Error fetching post with id ${id}:`, error);
        throw error;
    }
}

async function createPost(postData: PostUploadInterface): Promise<Post> {
    try {
        const res = await fetch(`${API_USE}api/v1/be/posts`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(postData)  
        });
        const data = await res.json();
        return data;
    } catch (error) {
        console.error("Error creating post:", error);
        throw error;
    }
}

async function updatePost(id: number, postData: PostUploadInterface): Promise<Post> {
    try {
        const res = await fetch(`${API_USE}api/v1/be/posts/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(postData)  
        });
        const data = await res.json();
        return data;
    }
    catch (error) {
        console.error(`Error updating post with id ${id}:`, error);
        throw error;
    }
}

async function deletePost(id: number): Promise<void> {
    try {
        await fetch(`${API_USE}api/v1/be/posts/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });
    } catch (error) {
        console.error(`Error deleting post with id ${id}:`, error);
        throw error;
    }
}


async function getAllCategoriesTrees(): Promise<CategoryTree[]> {
    try {
        const res = await fetch(`${API_USE}api/v1/be/categories/tree`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });
        const data = await res.json();
        return data;
    } catch (error) {
        console.error("Error fetching category trees:", error);
        throw error;
    }
}

async function createCategory(categoryData: CategoryUploadInterface): Promise<any> {
    try {
        const res = await fetch(`${API_USE}api/v1/be/categories`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(categoryData)
        });
        const data = await res.json();
        return data;
    } catch (error) {
        console.error("Error creating category:", error);
        throw error;
    }   
}

async function updateCategory(id: number, categoryData: CategoryUploadInterface): Promise<any> {
    try {
        const res = await fetch(`${API_USE}api/v1/be/categories/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(categoryData)
        });
        const data = await res.json();
        return data;
    } catch (error) {
        console.error(`Error updating category with id ${id}:`, error);
        throw error;
    }
}

async function deleteCategory(id: number): Promise<void> {
    try {
        await fetch(`${API_USE}api/v1/be/categories/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });
    } catch (error) {
        console.error(`Error deleting category with id ${id}:`, error);
        throw error;
    }   
}

export { getAllPosts, getPostById , createPost, updatePost, deletePost, getAllCategoriesTrees, createCategory, updateCategory, deleteCategory };
